import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DataGrid } from '@mui/x-data-grid';

function InventoryTable(props) {

    const columns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1,
            minWidth: 100,
            editable: false
        },
        {
            field: 'acumatica',
            headerName: 'Acumatica - Available',
            valueGetter: (params) => {
                if(!params.row.acumatica.available) return 0;
                return params.row.acumatica.available;
            }, 
            flex: 1,
            minWidth: 75,
            editable: false
        }, 
        {
            field:  `${props.warehouseName}`,
            headerName: `${props.warehouseName.charAt(0).toUpperCase() + props.warehouseName.slice(1)} - Available`,
            valueGetter: (params) => {
                if(!params.row?.[props.warehouseName]?.available) return 0;
                return params.row?.[props.warehouseName]?.available;
            },
            flex: 1,
            minWidth: 75,
            editable: false
        }, 
    ];

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
        <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
            <Stack direction = 'row' sx = {{width: '81%'}} spacing = {2}> 
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{ 
                        height: "1000px",
                        '& .red-row': {
                            backgroundColor: '#FAA0A0', 
                            '&:hover': {
                                backgroundColor: '#cc3333',  
                            },
                        },
                    }}
                    rows = {props.inventory}
                    getRowId = {(row) => row.id}
                    columns = {columns}
                    rowsPerPageOptions = {[25, 50, 100]}
                    checkboxSelection = {false}
                />
                <Tooltip title = {"Export Inventory."}  sx = {{width: '1000px'}} placement = "right-start" >
                    <span>
                        <IconButton 
                            aria-label = "exportInventory" 
                            onClick = {props.exportInventory} 
                            sx = {{mt: '5px', color: '#96605a'}}>
                            <FileDownloadIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Stack>
        </Box>
    </Box>
    )
}

export default InventoryTable;